/* istanbul ignore file */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import common_de from './translations/de/common.json';
import common_en from './translations/en/common.json';

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: 'en', // make this configurable
    whitelist: ['en', 'de'],
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    backend: {
      loadPath: '/api/locale/{{lng}}/{{ns}}'
    }
  });

i18n.addResourceBundle('en', 'common', common_en);
i18n.addResourceBundle('de', 'common', common_de);

export default i18n;
